export interface CompanyJD {
  [company: string]: {
    entry: string;
    mid: string;
    senior: string;
  };
}

export const companyJobDescriptions: CompanyJD = {
  google: {
    entry: `Role: Software Engineer
Requirements:
- Bachelor's degree in Computer Science or related field
- Knowledge of data structures, algorithms, and software design
- Experience with one or more programming languages like Python, Java, C++, or JavaScript
- Experience with web technologies
- Strong problem-solving skills

Responsibilities:
- Develop and maintain Google products and services
- Write clean, efficient, and reliable code
- Collaborate with cross-functional teams
- Participate in code reviews and contribute to architectural discussions
- Debug production issues`,

    mid: `Role: Software Engineer II
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 2-5 years of software development experience
- Strong coding skills in Python, Java, C++, or Go
- Experience with distributed systems, APIs, and microservices
- Understanding of software development methodologies

Responsibilities:
- Design and develop complex features for Google products
- Optimize code for performance and reliability at scale
- Mentor junior engineers and perform detailed code reviews
- Drive technical discussions and contribute to product roadmap
- Solve complex technical challenges across the stack`,

    senior: `Role: Senior Software Engineer
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 5+ years of software development experience
- Expert in one or more programming languages (Python, Java, C++, Go)
- Deep understanding of large-scale systems design
- Experience leading technical projects and mentoring engineers

Responsibilities:
- Architect and build advanced systems and features across Google products
- Lead design discussions and set technical direction for projects
- Improve engineering practices and drive technical excellence
- Collaborate with product managers to define product vision
- Mentor and grow other engineers to increase team impact`,
  },
  
  meta: {
    entry: `Role: Software Engineer
Requirements:
- Bachelor's degree in Computer Science, Engineering, or related field
- Experience building web or mobile applications
- Proficiency in at least one programming language (JavaScript, Python, etc.)
- Understanding of software development principles
- Passion for Meta's mission of connecting people

Responsibilities:
- Build new features for Facebook, Instagram, or other Meta platforms
- Write clean, efficient, and testable code
- Fix bugs and improve application performance
- Collaborate with designers and product managers
- Participate in code reviews and team meetings`,

    mid: `Role: Software Engineer III
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 2-5 years of software development experience
- Strong programming skills in React, JavaScript, PHP, or Python
- Experience with building scalable web applications
- Familiarity with data structures, algorithms, and system design

Responsibilities:
- Design and develop key features for Meta applications
- Build reusable code and libraries for future use
- Implement performance improvements and optimize database queries
- Collaborate cross-functionally with product managers and designers
- Mentor junior engineers and provide technical guidance`,

    senior: `Role: Senior Software Engineer
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 5+ years of software development experience
- Expert in building scalable systems and applications
- Experience leading projects and mentoring engineers
- Strong understanding of system architecture and design patterns

Responsibilities:
- Lead the architecture and development of major application features
- Drive technical strategy and make decisions on implementation approaches
- Optimize systems for performance, reliability, and scalability
- Drive best practices in coding, testing, and deployment
- Mentor team members and provide technical leadership`,
  },
  
  apple: {
    entry: `Role: Software Engineer
Requirements:
- Bachelor's degree in Computer Science or related technical field
- Knowledge of object-oriented programming languages (Swift, Objective-C)
- Understanding of iOS, macOS, or other Apple platforms
- Attention to detail and passion for quality
- Strong problem-solving and analytical skills

Responsibilities:
- Develop features for Apple software products
- Write clean, maintainable, and efficient code
- Test and debug software to ensure quality and reliability
- Collaborate with designers to implement intuitive user interfaces
- Follow Apple's development guidelines and best practices`,

    mid: `Role: Software Engineer II
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 2-5 years of software development experience
- Strong proficiency in Swift, Objective-C, or related languages
- Experience with Apple's frameworks and development tools
- Understanding of software architecture and design patterns

Responsibilities:
- Design and develop key features for Apple's software products
- Optimize applications for performance and responsiveness
- Ensure compatibility across multiple Apple platforms
- Collaborate with UX designers to create intuitive user experiences
- Mentor junior engineers and contribute to technical discussions`,

    senior: `Role: Senior Software Engineer
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 5+ years of software development experience
- Expert knowledge of Apple's development platforms and toolchains
- Deep understanding of software architecture and system design
- Experience leading technical projects and mentoring engineers

Responsibilities:
- Architect and implement complex features for Apple products
- Lead design discussions and technical planning
- Drive innovation and quality across development teams
- Optimize software performance, security, and reliability
- Mentor other engineers and help shape engineering culture`,
  },
  
  amazon: {
    entry: `Role: Software Development Engineer I
Requirements:
- Bachelor's degree in Computer Science or related field
- Knowledge of data structures, algorithms, and programming fundamentals
- Experience with one or more programming languages (Java, Python, C++)
- Basic understanding of cloud computing concepts
- Strong problem-solving abilities

Responsibilities:
- Develop, test, and deploy software solutions for Amazon services
- Write clean, efficient, and well-tested code
- Debug issues and implement fixes in production systems
- Collaborate with other developers, product managers, and operations teams
- Participate in code reviews and team meetings`,

    mid: `Role: Software Development Engineer II
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 2-5 years of software development experience
- Strong coding skills in Java, Python, or other languages
- Experience with distributed systems and cloud services
- Understanding of software development lifecycle

Responsibilities:
- Design and implement scalable services for Amazon platforms
- Lead development of significant features and components
- Troubleshoot and resolve complex technical issues
- Optimize systems for performance, cost, and reliability
- Mentor junior engineers and help improve team practices`,

    senior: `Role: Senior Software Development Engineer
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 5+ years of professional software development experience
- Expert knowledge of large-scale distributed systems
- Strong experience with AWS services and cloud architecture
- Technical leadership experience and mentoring skills

Responsibilities:
- Architect, design, and implement complex systems at massive scale
- Lead technical strategy for services and provide expertise
- Drive operational excellence and reliability engineering
- Work with product teams to define and build new features
- Mentor engineers and help grow technical capabilities`,
  },
  
  netflix: {
    entry: `Role: Software Engineer
Requirements:
- Bachelor's degree in Computer Science or related field
- Strong coding skills in one or more languages (Java, JavaScript, Python)
- Understanding of data structures and algorithms
- Knowledge of web technologies and frameworks
- Passion for streaming technology and entertainment

Responsibilities:
- Develop features for Netflix's streaming platform
- Write clean, maintainable, and efficient code
- Debug issues and improve application performance
- Collaborate with cross-functional teams
- Participate in code reviews and engineering discussions`,

    mid: `Role: Senior Software Engineer
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 2-5 years of software development experience
- Expert in Java, JavaScript, or full-stack development
- Experience with microservices and distributed systems
- Understanding of cloud infrastructure (AWS)

Responsibilities:
- Design and implement scalable services for Netflix's platform
- Build resilient systems that handle millions of users
- Optimize performance and reliability of streaming services
- Work closely with product managers and designers
- Mentor junior engineers and contribute to engineering culture`,

    senior: `Role: Lead Software Engineer
Requirements:
- Bachelor's or Master's degree in Computer Science or related field
- 5+ years of software development experience
- Deep expertise in large-scale distributed systems
- Experience with media streaming technologies
- Technical leadership and project management skills

Responsibilities:
- Lead architecture and design of major platform components
- Drive technical strategy and innovation for Netflix services
- Solve complex technical challenges related to streaming at scale
- Collaborate with engineering leaders across the organization
- Mentor and grow engineering talent within the team`,
  },

  microsoft: {
    entry: `Role: Software Engineer I
Requirements:
- Bachelor's degree in Computer Science or related field
- Experience with one or more programming languages: C#, Java, Python, or JavaScript
- Knowledge of data structures, algorithms, and object-oriented programming
- Basic understanding of cloud platforms (Azure, AWS, or Google Cloud)
- Strong problem-solving skills and ability to work in a collaborative team

Responsibilities:
- Develop and maintain software components for Microsoft products
- Write clean, well-tested code that meets requirements
- Debug and fix software issues
- Work with senior engineers to understand system architecture
- Participate in code reviews and engineering discussions`,

    mid: `Role: Software Engineer II
Requirements:
- 3+ years of software development experience
- Strong coding skills in C#, Java, or Python
- Experience with cloud computing, distributed systems, and microservices architecture
- Understanding of DevOps practices and CI/CD pipelines
- Ability to work in an agile development environment

Responsibilities:
- Design and implement complex features for Microsoft products
- Build scalable and maintainable services
- Improve performance and reliability of existing systems
- Mentor junior engineers and provide technical guidance
- Collaborate with product teams to define technical solutions`,

    senior: `Role: Principal Software Engineer
Requirements:
- 5+ years of experience in software development with a focus on scalable architectures
- Deep knowledge of cloud-native application development and containerization
- Strong problem-solving and debugging skills for complex distributed systems
- Experience in technical leadership, mentoring, and leading teams
- Expert-level knowledge in one or more programming languages

Responsibilities:
- Architect and lead development of major software components
- Drive technical excellence and innovation across engineering teams
- Design cloud-native solutions for large-scale enterprise applications
- Provide technical leadership and mentoring to other engineers
- Collaborate with leadership to define technology strategy and roadmap`,
  },

  jpmorgan: {
    entry: `Role: Financial Analyst
Requirements:
- Bachelor's degree in Finance, Economics, or a related field
- Basic understanding of financial markets, risk assessment, and investment strategies
- Strong analytical and quantitative skills
- Proficiency in Excel, PowerPoint, and financial modeling
- Ability to work in a high-pressure, fast-paced environment

Responsibilities:
- Conduct financial analysis and research for client presentations
- Build and maintain financial models and spreadsheets
- Assist with client presentations and pitch books
- Analyze market trends and competitive landscape
- Support senior team members with various financial analysis tasks`,

    mid: `Role: Investment Banking Associate
Requirements:
- 3+ years of experience in investment banking or financial analysis
- Strong understanding of corporate finance, valuation methods, and mergers & acquisitions
- Experience with Bloomberg, FactSet, or similar financial tools
- Strong communication and client-facing skills
- MBA or advanced degree in finance preferred

Responsibilities:
- Lead financial analysis for client transactions
- Develop detailed financial models for valuations and projections
- Prepare client presentations and pitch materials
- Participate in client meetings and due diligence processes
- Mentor analysts and junior team members`,

    senior: `Role: Vice President - Corporate Finance
Requirements:
- 5+ years of experience in financial strategy and investment banking
- Strong leadership experience in managing high-value transactions
- Expertise in risk assessment, regulatory compliance, and financial forecasting
- Ability to develop client relationships and negotiate deals
- Advanced degree in finance, business, or related field

Responsibilities:
- Lead complex financial transactions and strategic advisory engagements
- Develop and maintain key client relationships
- Oversee deal teams and ensure high-quality deliverables
- Structure and negotiate financial transactions
- Drive business development and identify new opportunities`,
  },

  johnson: {
    entry: `Role: Clinical Research Associate
Requirements:
- Bachelor's degree in Biology, Medicine, or a related field
- Knowledge of clinical trial phases and FDA regulations
- Strong attention to detail and data accuracy
- Excellent organizational and documentation skills
- Understanding of medical terminology and research protocols

Responsibilities:
- Assist in designing and implementing clinical trials
- Collect and document clinical research data
- Ensure compliance with research protocols and regulations
- Coordinate with research sites and healthcare professionals
- Prepare reports on clinical trial progress and findings`,

    mid: `Role: Medical Device Engineer
Requirements:
- 3+ years of experience in medical device development
- Expertise in regulatory compliance and quality assurance (ISO 13485, FDA guidelines)
- Experience in CAD software for medical device prototyping
- Strong problem-solving skills in designing innovative healthcare solutions
- Degree in Biomedical Engineering or related field

Responsibilities:
- Design and develop innovative medical devices
- Ensure compliance with quality and regulatory standards
- Collaborate with cross-functional teams including R&D and manufacturing
- Conduct testing and validation of medical devices
- Document design specifications and technical reports`,

    senior: `Role: Senior Biomedical Researcher
Requirements:
- 5+ years of experience in biomedical engineering or pharmaceutical research
- Track record of successful product development in healthcare technology
- Strong background in AI/ML applications in medical diagnostics
- Leadership experience in managing cross-functional research teams
- Advanced degree in Biomedical Engineering, Pharmaceutical Sciences, or related field

Responsibilities:
- Lead research initiatives for breakthrough medical technologies
- Oversee development of innovative healthcare solutions
- Direct clinical trials and product validation studies
- Collaborate with academic and industry partners
- Drive intellectual property strategy and patent portfolio development`,
  },

  walmart: {
    entry: `Role: Supply Chain Analyst
Requirements:
- Bachelor's degree in Supply Chain, Logistics, or Business
- Basic knowledge of inventory management and demand forecasting
- Strong analytical and problem-solving skills
- Proficiency in Excel, SQL, and data visualization tools
- Understanding of retail operations and logistics

Responsibilities:
- Analyze supply chain data to identify optimization opportunities
- Support inventory management and demand planning processes
- Prepare reports on key supply chain metrics
- Assist in coordinating with suppliers and distribution centers
- Support process improvement initiatives`,

    mid: `Role: Category Manager
Requirements:
- 3+ years of experience in retail merchandising or category management
- Strong understanding of pricing strategies and supplier negotiations
- Experience with retail analytics tools and market trends analysis
- Ability to develop and execute category growth plans
- Bachelor's degree in Business, Marketing, or related field

Responsibilities:
- Develop and implement category strategy and business plans
- Manage product assortment, pricing, and promotions
- Build and maintain relationships with suppliers and vendors
- Analyze sales performance and market trends
- Collaborate with store operations and supply chain teams`,

    senior: `Role: Director of Retail Operations
Requirements:
- 5+ years of experience in large-scale retail management
- Proven leadership skills in managing multi-location operations
- Strong knowledge of retail supply chain optimization
- Experience in implementing customer experience enhancement strategies
- Advanced degree in Business Administration or related field

Responsibilities:
- Direct retail operations across multiple locations
- Develop and implement strategic initiatives to drive growth
- Lead cross-functional teams in achieving operational excellence
- Optimize inventory management and supply chain efficiency
- Drive innovation in customer experience and digital integration`,
  },

  zara: {
    entry: `Role: Fashion Merchandising Assistant
Requirements:
- Bachelor's degree in Fashion, Business, or Retail Management
- Strong understanding of fashion trends and consumer behavior
- Experience with inventory management and store operations
- Strong organizational and analytical skills
- Passion for fashion retail and brand aesthetics

Responsibilities:
- Assist in product selection and assortment planning
- Monitor inventory levels and support replenishment processes
- Analyze sales data and identify trending products
- Support visual merchandising initiatives in stores
- Coordinate with design and production teams`,

    mid: `Role: Visual Merchandising Manager
Requirements:
- 3+ years of experience in fashion merchandising and store layout planning
- Expertise in brand presentation and in-store customer experience
- Strong communication and collaboration skills with designers and store teams
- Experience in driving sales through visual strategies
- Degree in Fashion Merchandising, Design, or related field

Responsibilities:
- Develop and implement visual merchandising strategies
- Create compelling store layouts and product displays
- Train and mentor store staff on visual merchandising standards
- Collaborate with marketing on seasonal campaigns
- Analyze visual merchandising performance and make adjustments`,

    senior: `Role: Retail Operations Director
Requirements:
- 5+ years of experience in managing fashion retail operations
- Strong leadership in sales performance optimization
- Expertise in supply chain and logistics for fashion brands
- Experience in digital retail transformation and omnichannel strategies
- Advanced degree in Business, Fashion Management, or related field

Responsibilities:
- Lead overall retail strategy and operations
- Drive omnichannel integration and digital transformation
- Optimize inventory management and supply chain processes
- Develop and implement customer experience initiatives
- Oversee performance metrics and drive continuous improvement`,
  },

  tesla: {
    entry: `Role: Mechanical Engineer
Requirements:
- Bachelor's degree in Mechanical or Electrical Engineering
- Basic experience with CAD software (SolidWorks, AutoCAD)
- Understanding of electric vehicle (EV) components and battery technology
- Hands-on experience with prototyping and mechanical design
- Innovative thinking and problem-solving skills

Responsibilities:
- Design and develop mechanical components for Tesla vehicles
- Create and modify 3D CAD models and engineering drawings
- Support testing and validation of mechanical systems
- Collaborate with cross-functional engineering teams
- Participate in design reviews and engineering discussions`,

    mid: `Role: Electrical Systems Engineer
Requirements:
- 3+ years of experience in electrical engineering for automotive applications
- Experience with embedded systems and firmware development
- Strong knowledge of automotive safety regulations and standards
- Proficiency in MATLAB/Simulink
- Degree in Electrical Engineering or related field

Responsibilities:
- Design and develop electrical systems for Tesla vehicles
- Create electrical architecture and component specifications
- Conduct testing and validation of electrical systems
- Collaborate with software and mechanical engineering teams
- Troubleshoot and resolve complex electrical issues`,

    senior: `Role: Lead Vehicle Software Engineer
Requirements:
- 5+ years of experience in embedded software development for automotive systems
- Strong understanding of autonomous vehicle technologies and AI-driven control systems
- Experience with cloud-connected vehicles and IoT integration
- Leadership experience in cross-functional engineering teams
- Advanced degree in Computer Science, Electrical Engineering, or related field

Responsibilities:
- Lead software architecture and development for vehicle systems
- Oversee integration of autonomous driving features
- Drive innovation in vehicle software and user experience
- Collaborate with hardware teams on system-level design
- Mentor engineering teams and establish best practices`,
  },

  exxonmobil: {
    entry: `Role: Petroleum Engineer
Requirements:
- Bachelor's degree in Petroleum or Chemical Engineering
- Basic knowledge of oil extraction techniques and drilling operations
- Strong problem-solving and analytical skills
- Willingness to work in field-based operations
- Understanding of reservoir engineering principles

Responsibilities:
- Assist in designing and optimizing oil extraction processes
- Analyze well performance and production data
- Support drilling operations and reservoir management
- Conduct geological and reservoir studies
- Collaborate with multidisciplinary teams on field development`,

    mid: `Role: Renewable Energy Consultant
Requirements:
- 3+ years of experience in energy systems and sustainable solutions
- Knowledge of wind, solar, and hydro energy technologies
- Strong background in energy efficiency and carbon footprint reduction strategies
- Experience with power grid modeling and optimization
- Degree in Environmental Engineering, Energy Systems, or related field

Responsibilities:
- Develop renewable energy project plans and feasibility studies
- Analyze energy consumption patterns and identify optimization opportunities
- Design and implement sustainable energy solutions
- Prepare environmental impact assessments
- Collaborate with stakeholders on energy transition strategies`,

    senior: `Role: Director of Energy Strategy
Requirements:
- 5+ years of experience in the energy sector
- Expertise in both traditional and renewable energy sources
- Strong leadership and business development experience in energy markets
- Experience with international energy policies and regulations
- Advanced degree in Energy Management, Business, or related field

Responsibilities:
- Lead strategic planning for energy portfolio diversification
- Direct sustainable energy initiatives and carbon reduction strategies
- Oversee major energy project developments
- Develop partnerships with governments and industry stakeholders
- Drive innovation in energy technologies and solutions`,
  },

  warnerbros: {
    entry: `Role: Production Assistant
Requirements:
- Bachelor's degree in Film, Media, or related field
- Strong organizational and multitasking skills
- Ability to support production teams with scheduling, logistics, and on-set coordination
- Basic knowledge of editing software (Adobe Premiere, Final Cut Pro)
- Passion for storytelling and entertainment

Responsibilities:
- Assist with day-to-day production operations
- Coordinate schedules, equipment, and locations
- Support directors, producers, and crew members
- Prepare and distribute production materials
- Take notes during shoots and production meetings`,

    mid: `Role: Content Acquisition Manager
Requirements:
- 3+ years of experience in media licensing, content distribution, or acquisitions
- Strong understanding of international media rights and contracts
- Negotiation skills for acquiring third-party content for TV and streaming platforms
- Ability to analyze audience trends and suggest content strategies
- Degree in Film, Media Business, or related field

Responsibilities:
- Identify and acquire content for Warner Bros. Discovery platforms
- Negotiate licensing agreements and content deals
- Evaluate content performance and audience engagement
- Collaborate with programming and marketing teams
- Develop relationships with content creators and distributors`,

    senior: `Role: Head of Digital Content Strategy
Requirements:
- 5+ years of experience in content development, streaming platforms, or digital media
- Strong leadership and strategic planning skills
- Experience in leading content curation and acquisition strategies for global audiences
- Understanding of advertising models, subscription growth, and digital monetization
- Advanced degree in Media Management, Business, or related field

Responsibilities:
- Lead digital content strategy across multiple platforms
- Oversee content acquisition, development, and distribution
- Drive subscriber growth and audience engagement strategies
- Direct multiplatform content initiatives and innovations
- Collaborate with executive leadership on business development`,
  },

  universal: {
    entry: `Role: A&R Coordinator (Artists & Repertoire)
Requirements:
- Bachelor's degree in Music Business, Communications, or related field
- Passion for discovering new musical talent
- Strong understanding of music trends and industry analytics
- Ability to coordinate artist meetings, contracts, and studio sessions
- Knowledge of various music genres and industry landscape

Responsibilities:
- Assist in scouting and identifying potential new artists
- Support A&R team with administrative tasks
- Coordinate studio sessions and production schedules
- Help prepare artist contracts and agreements
- Research music trends and compile industry reports`,

    mid: `Role: Music Marketing Manager
Requirements:
- 3+ years of experience in digital marketing and social media for the music industry
- Experience with artist branding, promotional campaigns, and audience engagement
- Strong knowledge of platforms like Spotify, Apple Music, and YouTube Music
- Ability to collaborate with artists, labels, and sponsors for music promotion
- Degree in Marketing, Music Business, or related field

Responsibilities:
- Develop and execute marketing campaigns for artist releases
- Create strategic social media and digital marketing plans
- Analyze marketing performance and optimize campaign strategies
- Coordinate with artists, managers, and streaming platforms
- Plan and execute promotional events and activations`,

    senior: `Role: Head of Global Music Partnerships
Requirements:
- 5+ years of experience in business development for music streaming, events, or partnerships
- Strong network in the music industry for securing brand sponsorships and collaborations
- Expertise in digital streaming analytics and revenue optimization
- Experience negotiating contracts and licensing agreements
- Advanced degree in Business, Music Management, or related field

Responsibilities:
- Lead global partnership strategy for Universal Music Group
- Develop and manage relationships with major brands and platforms
- Negotiate high-value sponsorship and licensing deals
- Drive revenue growth through strategic partnerships
- Oversee international team of partnership managers`,
  },

  espn: {
    entry: `Role: Sports Production Assistant
Requirements:
- Bachelor's degree in Journalism, Communications, or related field
- Passion for sports and strong knowledge of major leagues (NFL, NBA, FIFA, etc.)
- Ability to assist in video editing, research, and content development
- Strong writing and storytelling skills for sports content
- Basic understanding of broadcast production

Responsibilities:
- Assist in the production of sports programming
- Research statistics, player information, and game history
- Help with script writing and content preparation
- Support live broadcast operations
- Coordinate with production crew and on-air talent`,

    mid: `Role: Sports Content Producer
Requirements:
- 3+ years of experience in sports media production
- Experience working with live broadcasting, studio shows, or digital content creation
- Strong understanding of audience engagement strategies for sports fans
- Ability to manage editorial calendars and coordinate content with sports analysts
- Degree in Broadcast Journalism, Media Production, or related field

Responsibilities:
- Produce engaging sports content for broadcast and digital platforms
- Plan and execute live sports broadcasts
- Direct studio shows and segments
- Manage production teams and resources
- Develop innovative ways to present sports stories and analysis`,

    senior: `Role: Director of Sports Broadcasting
Requirements:
- 5+ years of experience in sports media, television, or streaming platforms
- Leadership experience in live broadcasting and event coverage
- Strong expertise in audience engagement, sponsorship deals, and broadcasting rights
- Ability to develop and execute large-scale sports media strategies
- Advanced degree in Media Management, Business, or related field

Responsibilities:
- Lead overall sports broadcasting strategy and operations
- Oversee major sporting event coverage and special programming
- Direct cross-functional teams including production, talent, and technology
- Negotiate broadcasting rights and manage partnerships
- Drive innovation in sports content delivery and viewer experience`,
  },
}; 